import React from 'react'

class LogoFront extends React.Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#AFBEBE" d="M287.57 469.453c-42.23-32.016-94.64-11.304-165.21-26.908C34.57 423.137 15.38 337.537 15.38 337.537c10.89-13.616 19.415-67.308 19.415-67.308l-12.708 2.722c1.816-31.768 42.66-85.32 42.66-85.32l-9.984-1.816C98.327 131.36 165.223 113 165.223 113c65.888-23.2 110.096 34.7 110.096 34.7 13.894 13.765 12.282 31.413 12.282 31.413 13.352.672 42.172 10.336 42.172 10.336 68.98 25.414 0 90.534 0 90.534s4.54-16.112-9.984-22.464c-14.523-6.35-68.095 5.433-68.095 5.433s39.96 6.064 50.848 2.736c0 0-.904 3.63-9.072 6.35-8.166 2.724-35.854 9.252-43.19 15.244-4.832 3.94-19.81 11.376 2.348 42.848 42.088 59.78 34.944 139.32 34.944 139.32"/>
                    <path fill="#FEFEFE" d="M243.31 191.033l-20.808-20.396-3.592 3.66 20.812 20.4"/>
                    <path fill="#FEFEFE" d="M243.142 174.056l-20.4 20.812-3.664-3.592 20.4-20.812"/>
                </g>
            </svg>

        );
    }
}

export default LogoFront



// WEBPACK FOOTER //
// ../components/SVG/LogoFront.jsx